'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../index-6ed9f31c.js');
var formik_esm = require('../../formik.esm-1c3621f3.js');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-02f83f64.js');
var components_Typography_Typography = require('../Typography/Typography.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
require('styled-components');
require('../../extends-f8003900.js');
require('../../objectWithoutProperties-aa43106a.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../colorBuilder-0e3465cf.js');
require('../../polished.esm-0312677e.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
require('../NuDSProvider/NuDSProvider.js');
require('../../breakpoints-7bb24b2d.js');
require('../../unsupportedIterableToArray-a6f9513d.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../theme-340a6118.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../defineProperty-3cad0327.js');
require('../../xstyled-prop-types.es-7d7acd76.js');
require('../../utils/isType/isType.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject;
var ErrorText = xstyledStyledComponents_es.styled(components_Typography_Typography['default'])(_templateObject || (_templateObject = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  color: ", ";\n  margin-top: 0.5rem;\n  display: block;\n  position: relative;\n"])), styles_themeUtils.nuDSColor('error'));
ErrorText.propTypes = {
  children: index.PropTypes.node.isRequired,
  id: index.PropTypes.string.isRequired
};
ErrorText.defaultProps = {
  role: 'alert',
  variant: 'paragraph2',
  strong: true
};
ErrorText.displayName = 'ErrorText';

function FieldErrorMessage(_ref) {
  var name = _ref.name,
      errorMessageId = _ref.errorMessageId;
  return /*#__PURE__*/React__default['default'].createElement(formik_esm.ErrorMessage, {
    name: name
  }, function (msg) {
    return /*#__PURE__*/React__default['default'].createElement(ErrorText, {
      id: errorMessageId
    }, msg);
  });
}

FieldErrorMessage.propTypes = {
  errorMessageId: index.PropTypes.string.isRequired,
  name: index.PropTypes.string.isRequired
};

exports.default = FieldErrorMessage;
//# sourceMappingURL=FieldErrorMessage.js.map
